<template>
  <div>
    <div class="ibox ">
      <div class="ibox-title">
        <h5>Money Sites</h5>
        <div class="ibox-tools pull-right">
          <a class="collapse-link">
            <i class="fa fa-chevron-up"></i>
          </a>
        </div>
      </div>
      <div class="ibox-content">
        <table class="table table-hover" id="money-sites">
          <thead>
          <tr>
            <th>Site</th>
            <th>Network</th>
            <th>KWs</th>
            <th>Links</th>
          </tr>
          </thead>
          <tbody>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import { Query } from '../../../../../mixins/helperMixin'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      sites: [],
      table: null
    }
  },
  mixins: [Query],
  mounted () {
    this.loadMoneySites()
  },
  computed: {
    ...mapGetters({
      filters: 'getViewFilters'
    })
  },
  watch: {
    filters () {
      this.loadMoneySites()
    }
  },
  methods: {
    loadMoneySites () {
      this.table = $('#money-sites').DataTable()
      this.table.rows().remove()
      axios.get('/pbn/list?type=money&' + this.buildQuery(this.filters))
        .then(r => {
          this.sites = r.data.data
          this.sites.forEach(row => {
            this.table.row.add([
              `<router-link to="/pbn/${row.punyDomain}">${row.domain}</router-link>`,
              row.client.name,
              0,
              row.linkTagsObj ? row.linkTagsObj.siteCount : 0
            ])
          })
          this.table.draw(true)
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Dashboard/Overview/MoneySites.vue